var exports = {
  "kL": "x804f0401--647aa5--container",
  "DD": "x804f0401--647aa5--title",
  "uf": "x804f0401--647aa5--stars",
  "kM": "x804f0401--647aa5--stars-item",
};

module.exports = exports;
